import axios from "axios";
import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import moment from "moment";
import ExportToExcel from "../../SExport/ExportToExcle";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
import Decimal from "../../ShortCutComponents/Decimal";
import { generateCriteriaString } from "../../ShortFunction/shortFunctions";

// import { TableSumCustom } from "../../ShortFunction/TableSumCustom";
import { baseurl } from "../../../../baseurl";
import "../../../../stickyHeaderReport.css";
// import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./formsTable.css";
import "./baseForms.css";
import "../../../../index.css";
import swal from "sweetalert";

let companyId = localStorage.getItem("companyId");
let companyName = localStorage.getItem("companyName");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");

function dueFormators(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell; //  2200
  if (typeof cell === "string") {
    newCell = parseFloat(cell);
  }

  if (newCell) {
    newCell = newCell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    newCell = companySymbolCurrency + " " + newCell;
  } else {
    newCell = "-";
  }
  return <div> {newCell}</div>;
}

export default function SaleSummary(props) {
  const [data, setData] = useState({
    fromDate: "",
    toDate: "",
    customer: "",
    clientLov: "",
    customer_id: "",
    customerName: "",
    customerEmail: "",
    radioBtn: "",
    radioBtn2: "",
    criteriaString: "All",
    collapseCriteria: true,
  });
  const [showAsInteger, setShowAsInteger] = useState(false);
  const [showDeliveryDate, setShowDeliveryDate] = useState(false);

  const due_Formators = (cell, row, enumObject, index) => {
    let newCell = "";
    newCell = cell;
    if (typeof cell === "string") {
      newCell = parseFloat(cell.replace(/,/g, ""));
    }

    if (newCell) {
      newCell = newCell?.toLocaleString("en-US", {
        maximumFractionDigits: showAsInteger ? 0 : 2,
        minimumFractionDigits: showAsInteger ? 0 : 2,
      });

      // newCell = companySymbolCurrency + " " + newCell;
    } else {
      newCell = "0";
    }
    return newCell;
  };
  const [permission, setPermission] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const listOfSum = [
    "Value Excl. Amount",
    "Discount",
    "Sale Tax Amount",
    "Value Incl. Amount",
    "Paid Amount",
    "CreditNote Amount",
    "Overdue",
    "Due",
  ];
  const colourOptions = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ];
  const listOfColLables = [
    { align: "center", value: "Sr No." },
    { align: "center", value: "Deliverd Date" },
    { align: "center", value: "order Type" },
    { align: "center", value: "Total" },
    { align: "center", value: "Discount" },
    { align: "center", value: "Tax" },
    { align: "center", value: "Sub-Total" },
    { align: "center", value: showDeliveryDate ? "Dmg & Dlv" :"Surcharge" },
    { align: "center", value: "Net-Total" },
  ];

  const listOfColKey = [
    { align: "center", value: "sr_no" },
    { align: "left", value: "deliverd_Date" },
    { align: "left", value: "order_type_desc" },
    { align: "right", value: "total" },
    { align: "center", value: "discount" },
    { align: "center", value: "stax_amount" },
    { align: "center", value: "sub_total" },
    { align: "center", value: "sale_surch" },
    { align: "center", value: "net_total" },
  ];
  const [table, setTable] = useState({
    OverViewDataTable: [],
    filteredData: [],
  });
  const [filteredData, setFilteredData] = useState([]);
  const [Item, setItem] = useState({
    itemLov: "",
    item_id: "",
    itemName: "",
  });

  useEffect(() => {
    // getAccountsSummary();
    console.log("companyName", companyName);
    if (companyName == "Dollar Junction") {
      setShowAsInteger(true);
    }
  }, []);
  // const CustomerHandleChange = (customer_id) => {
  //   // const customer = customer_id.find((element) => element.id === "-1");
  //   const customer = customer_id.id === "-1" ? true : false;

  //   if (customer) {
  //     setData({
  //       ...data,
  //       customer_id: [],
  //     });
  //   } else {
  //     setData({
  //       ...data,
  //       customer_id,
  //       customerName: customer_id?.label,
  //       customerEmail: customer_id?.email,
  //     });
  //   }
  // };
  const funPrintView = (data1, headers, headerKeyMap, allData) => {
    const { radioBtn, radioBtn2 } = allData;
    let fromDate = allData.fromDate
      ? moment(allData.fromDate).format("DD-MMM-YYYY")
      : "All";
    let toDate = allData.toDate
      ? moment(allData.toDate).format("DD-MMM-YYYY")
      : "All";
    let radioOption =
      radioBtn === "1"
        ? "All"
        : radioBtn === "2"
          ? "Fully Paid"
          : radioBtn === "3"
            ? "Due (Only Exclusive Fully Paid)"
            : radioBtn === "4"
              ? "Over Due"
              : "All";
    let radioOption2 =
      radioBtn2 === "1"
        ? "All"
        : radioBtn2 === "2"
          ? "Invoice Only"
          : radioBtn2 === "3"
            ? "Draft Only"
            : radioBtn2 === "4"
              ? "Estimate Only"
              : "All";

    let dateCriteria =
      fromDate === "All" && toDate === "All"
        ? {
            label: "Date",
            value: "All",
          }
        : ({
            label: "From Date",
            value: fromDate,
          },
          {
            label: "To Date",
            value: toDate,
          });
    let criteria = [
      // dateCriteria,
      // {
      //   label: "Customer",
      //   value: customer_id?.label ? customer_id?.label : "All",
      // },
      // {
      //   label: "Item",
      //   value: item_id?.label ? item_id?.label : "All",
      // },
      // {
      //   label: "Status",
      //   value: radioOption,
      // },
      // {
      //   label: "Invoice Type",
      //   value: radioOption2,
      // },
    ];
    const formattedPrintData = table.printData.map((item) => ({
      sr_no: item.sr_no,
      deliverd_Date: item.deliverd_Date,
      order_type_desc: item.order_type_desc,
      total: due_Formators(item.total),
      discount: due_Formators(item.discount),
      stax_amount: due_Formators(item.stax_amount),
      sub_total: due_Formators(item.sub_total),
      sale_surch: due_Formators(item.sale_surch),
      net_total: due_Formators(item.net_total),
    }));
    const reportState = {
      data: formattedPrintData,
      headers: headers,
      headerKeyMap: headerKeyMap,
      goBackUrl: "/dailySaleOrderWise",
      dynamicInvMessage: "Daily Sale Order Wise Report",
      reportName: "Daily_Sale_Order_Wise_Report",
      criteria,
      criteriaString: data.criteriaString,
    };
    localStorage.setItem("reportState", JSON.stringify(reportState));
    window.open("#/PrintReportsNew", "_blank");
    // props.history.push({
    //   pathname: "/PrintReports",
    //   state: {
    //     data: formattedPrintData,
    //     headers: headers,
    //     headerKeyMap: headerKeyMap,
    //     goBackUrl: "/dailySaleOrderWise",
    //     dynamicInvMessage: "Daily Sale Order Wise Report",
    //     reportName: "Daily_Sale_Order_Wise_Report",
    //     criteria,
    //     criteriaString: data.criteriaString,
    //   },
    // });
  };
  const graph = () => {
    swal({
      title: "Coming Soon",
      text: "This feature is under development",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
  };
  const itemHandleChange = (item_id) => {
    // const item = item_id.find((element) => element.id === "-1");
    const item = item_id.id === "-1";
    if (item) {
      setItem({
        ...Item,
        item_id: [],
      });
    } else {
      setItem({
        ...Item,
        item_id,
        itemName: item_id?.label,
      });
    }
  };

  const onChangeRadio = (e) => {
    setData({
      ...data,
      radioBtn: e.target.value,
    });
  };
  const onChangeRadio2 = (e) => {
    setData({
      ...data,
      radioBtn2: e.target.value,
    });
  };
  const indexN = (cell, row, enumObject, index) => {
    return <div>{index + 1}</div>;
  };
  const getAccountsSummary = (
    startDate,
    endDate,
    orderType_id,
    multiPosBranch,
    branch_id,
    saleChannel_id,
      devFromDate,
      devToDate,
  ) => {
    setIsLoading(true);

    let sDate = startDate ? moment(startDate).format("YYYY-MM-DD") : null;
    let eDate = endDate ? moment(endDate).format("YYYY-MM-DD") : null;
    const deliveryFromDate = devFromDate ? moment(devFromDate).format("YYYY-MM-DD") : null;
    const deliveryToDate = devToDate ? moment(devToDate).format("YYYY-MM-DD") : null;
    
    console.log("multiPosBranch", multiPosBranch);
    console.log("branch_id", branch_id);
    // let sysDate = new Date();
    // return;
    axios
      .post(
        `${baseurl}/repots/getDailySaleOrderWiseReport`,
        {
          companyId,
          fromDate: sDate,
          toDate: eDate,
          deliveryFromDate:deliveryFromDate,
          deliveryToDate:deliveryToDate,
          orderType: orderType_id?.id, // orderType_id?.multiOrderType,
          saleChannel_id: saleChannel_id?.id, //payMode_id?.multiPayMode,
          username,
          multiPosBranch: multiPosBranch || branch_id?.id || branch_id, // multiPosBranch ? multiPosBranch : branch_id?.id,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )

      .then(function (response) {
        let callData = response.data.data;

        let totalSumAll = {
          total: 0,
          discount: 0,
          stax_amount: 0,
          sub_total: 0,
          sale_surch: 0,
          net_total: 0,
        };
        let objEmpty = {
          sr_no: "",
          deliverd_Date: "",
          order_type_desc: "",
          total: "",
          discount: "",
          stax_amount: "",
          sub_total: "",
          sale_surch: "",
          net_total: "",
          // valueIncAmt: "",
        };
        let newArr = [
          {
            sr_no: "Daily Sale Order Wise Report",
            deliverd_Date: "",
            order_type_desc: "",
            total: "",
            discount: "",
            stax_amount: "",
            sub_total: "",
            sale_surch: "",
            net_total: `*Note : All figures indicated are in the company currency (  ${companySymbolCurrency} )`,
          },
          objEmpty,
          {
            sr_no: "sr_no",
            deliverd_Date: "Delivery Date",
            order_type_desc: "Type",
            total: "Total",
            discount: "Dicount",
            stax_amount: "Sale Tax",
            sub_total: "Sub Total",
            sale_surch: showDeliveryDate ? "Dmg & Dlv" :"Surcharge",
            net_total: "Net Total",
          },
        ];
        let sumTotal = 0;
        let sumDiscount = 0;
        let sumSaleTaAmt = 0;
        let sumSubTotal = 0;
        let sumSurcharge = 0;
        let sumNetTotal = 0;
        let printData = [];
        for (let index = 0; index < callData.length; index++) {
          let element = callData[index];

          sumTotal = sumTotal + Number(element?.total);
          sumDiscount = sumDiscount + Number(element?.discount);
          sumSaleTaAmt = sumSaleTaAmt + Number(element?.stax_amount);
          sumSubTotal = sumSubTotal + Number(element?.sub_total);
          sumSurcharge = sumSurcharge + Number(element?.sale_surch);
          sumNetTotal = sumNetTotal + Number(element?.net_total);
          // sumCredit = sumCredit + Number(element?.CR_NOTE);
          // sumOverDue = sumOverDue + Number(calOverDue);
          // sumDue = sumDue + Number(calDue);

          totalSumAll = {
            sumTotal: totalSumAll.total + Number(element?.total),
            sumDiscount: totalSumAll.discount + Number(element?.discount),
            sumSaleTaAmt:
              totalSumAll.stax_amount + Number(element?.stax_amount),
            sumSubTotal: totalSumAll.sub_total + Number(element?.sub_total),
            sumSurcharge: totalSumAll.sale_surch + Number(element?.sale_surch),
            sumNetTotal: totalSumAll.net_total + Number(element?.net_total),

            // due:element?.
          };

          // }

          // else {
          //   calBalance = 0;
          // }
          // element["balOverDue"] = calOverDue.toFixed(2);
          // element["balDue"] = calDue.toFixed(2);
          newArr.push({
            sr_no: index + 1,
            deliverd_Date: element["deliverd_Date"],
            order_type_desc: element["order_type_desc"],
            total: Number(element["total"]),
            discount: Number(element["discount"]),
            stax_amount: Number(element["stax_amount"]),
            sub_total: Number(element["sub_total"]),
            sale_surch: Number(element["sale_surch"]),
            net_total: Number(element["net_total"]),
          });
          printData.push({
            sr_no: index + 1,
            deliverd_Date: element["deliverd_Date"],
            order_type_desc: element["order_type_desc"],
            total: due_Formators(Number(element["total"])),
            discount: due_Formators(Number(element["discount"])),
            stax_amount: due_Formators(Number(element["stax_amount"])),
            sub_total: due_Formators(Number(element["sub_total"])),
            sale_surch: due_Formators(Number(element["sale_surch"])),
            net_total: due_Formators(Number(element["net_total"])),
          });
          // calOverDue = 0;
          // calDue = 0;
        }
        // totalSumAll = Object.keys(totalSumAll).map((key, index) => [
        //   totalSumAll[key],
        // ]);
        newArr.push(objEmpty);
        newArr.push({
          sr_no: "",
          deliverd_Date: "",
          order_type_desc: "Total",
          total: sumTotal,
          discount: sumDiscount,
          stax_amount: sumSaleTaAmt,
          sub_total: sumSubTotal,
          sale_surch: sumSurcharge,
          net_total: sumNetTotal,
        });

        let mainScreenDataTable = [...printData];
        printData.push({
          sr_no: "",
          deliverd_Date: "",
          order_type_desc: "Total",
          total: due_Formators(sumTotal),
          discount: due_Formators(sumDiscount),
          stax_amount: due_Formators(sumSaleTaAmt),
          sub_total: due_Formators(sumSubTotal),
          sale_surch: due_Formators(sumSurcharge),
          net_total: due_Formators(sumNetTotal),
        });
        setTable({
          ...table,
          OverViewDataTable: mainScreenDataTable,
          printData,
          totalSumAll,
          listOfData: newArr,
        });
        setIsLoading(false);

        setFilteredData(JSON.parse(JSON.stringify(mainScreenDataTable)));
      })
      .catch(function (error) {
        setIsLoading(false);

        console.log(error);
      });
  };
  const defaultValueLov = {
    id: "-1",
    label: "All",
  };
  const handleFind = (p) => {
    console.log("p", p);
    const {
      fromDate,
      toDate,
      orderType_id,
      multiOrderTypeLabel,
      multiPosBranchLabel,
      multiPosBranch,
      branch_id,
      saleChannel_id,
      multiSaleChannelLabel,
      devFromDate,
      devToDate,
    } = p;
    // const { item_id } = Item;
    // return;
    const critObj = {
      fromDate,
      toDate,
      orderType_id,
      multiOrderTypeLabel: multiOrderTypeLabel || orderType_id?.label,
      multiPosBranchLabel: multiPosBranchLabel || branch_id?.label,
      multiPosBranch: multiPosBranch || branch_id,
      branch_id,
      multiSaleChannelLabel: multiSaleChannelLabel || saleChannel_id?.label,
      devFromDate,
      devToDate,
    };
    const criteriaString = generateCriteriaString(critObj);
    setData({
      criteriaString: criteriaString,
    });
    console.log("criteriaString :>> ", criteriaString);

    console.log(
      "fromDate, toDate, orderType_id, ",
      fromDate,
      toDate,
      orderType_id,
      saleChannel_id,
      multiPosBranch,
      branch_id,
    );
    let BranchCheck = multiPosBranch || branch_id;
    if (!BranchCheck) {
      swal({
        title: "Branch Not Selected",
        text: "Please select branch",
        icon: "warning",
      });
      return;
    }
    getAccountsSummary(
      fromDate,
      toDate,
      orderType_id,
      multiPosBranch,
      branch_id,
      saleChannel_id,
      devFromDate,
      devToDate,
    );
  };
  const { fromDate, toDate, customer_id, clientLov, clientLov1 } = data;
  const { itemLov, itemName, item_id } = Item;
  // const { orderType_id, orderTypeLov, orderType } = OrderType;
  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to last",
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: filteredData?.length || 100 }, // fallback
    ],
    custom: true,
  };
  const totalSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.total.replace(/,/g, "")),
    0,
  );
  const totaldiscount = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.discount.replace(/,/g, "")),
    0,
  );
  const totalstax_amount = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.stax_amount.replace(/,/g, "")),
    0,
  );
  const totalsub_total = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.sub_total.replace(/,/g, "")),
    0,
  );
  const totalsale_surch = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.sale_surch.replace(/,/g, "")),
    0,
  );
  const totalnet_total = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.net_total.replace(/,/g, "")),
    0,
  );
  const columns = [
    {
      dataField: "deliverd_Date",
      text: "Delivery Date",
      sort: true,
      style: {
        textAlign: "Center",
      }, 
      footer: "",
    },
    {
      dataField: "order_type_desc",
      text: "Type",
      sort: true,
      style: {
        textAlign: "Center",
      },
      footer: "Total",
      footerStyle: {
        textAlign: "Center",
      },
    },
    {
      dataField: "total",
      formatter: due_Formators,

      text: "Total",
      sort: true,
      // footer: (columnData) => {
      //   const sum = columnData.reduce(
      //     (acc, item) => acc + parseFloat(item.replace(/,/g, "")),
      //     0
      //   );
      //   return new Intl.NumberFormat().format(sum); // Format the sum with commas
      // },
      footer: () => (totalSum ? due_Formators(totalSum) : 0),

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "discount",
      formatter: due_Formators,

      text: "Discount",
      sort: true,
      // footer: () => new Intl.NumberFormat().format(totaldiscount),
      footer: () => (totaldiscount ? due_Formators(totaldiscount) : 0),
      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "stax_amount",
      formatter: due_Formators,

      text: "Tax",
      sort: true,
      // footer: () => new Intl.NumberFormat().format(totalstax_amount),
      footer: () => (totalstax_amount ? due_Formators(totalstax_amount) : 0),

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "sub_total",
      text: "Sub-Total",
      formatter: due_Formators,

      sort: true,
      // footer: () => new Intl.NumberFormat().format(totalsub_total),
      footer: () => (totalsub_total ? due_Formators(totalsub_total) : 0),

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "sale_surch",
      formatter: due_Formators,

      text: `${showDeliveryDate ? "Dmg & Dlv" : "Surcharge"}`,
      sort: true,
      // footer: () => new Intl.NumberFormat().format(totalsale_surch),
      footer: () => (totalsale_surch ? due_Formators(totalsale_surch) : 0),

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "net_total",
      formatter: due_Formators,

      text: "Net-Total",
      sort: true,
      footer: () => (totalnet_total ? due_Formators(totalnet_total) : 0),
      // footer: () => new Intl.NumberFormat().format(totalnet_total),

      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
  ]; 
  const allowDelivCol = (p) => {
    console.log("p>>>", p);
    setShowDeliveryDate(p.colAllowed)
    
  };
const tableColumns = showDeliveryDate
  ? columns
  : columns.filter(col => col.dataField !== "deliverd_Date");

const listOfColLablesMt = showDeliveryDate
  ? listOfColLables
  : listOfColLables.filter(col => col.value !== "Deliverd Date");

const listOfColKeyMt = showDeliveryDate
  ? listOfColKey
  : listOfColKey.filter(col => col.value !== "deliverd_Date");
  
  // const filteredData = table.OverViewDataTable.filter((row) =>
  //   Object.values(row).some((value) =>
  //     String(value).toLowerCase().includes(searchText.toLowerCase())
  //   )
  // );
  const defaultSorted = [
    {
      dataField: "name",
      order: "desc",
    },
  ];
  const handleDynamicColapse = (p) => {
    console.log("p", p);
    const { collapseCriteria } = p;
    setData({
      ...data,
      collapseCriteria,
    });
  };
  const sendSearchedData = (p) => {
    console.log("p", p);
    const { filteredData } = p;
    setFilteredData(filteredData);
  };
  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            isLoading ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Daily Sale Order Wise Report"
            lovs={["ordertype","delDates", "branch", "saleChannel"]}
            // status={1}
            // invoiceType={1}
            companyId={companyId}
            token={token}
            username={username}
            // callBack={() => {}}
            handleFind={(p) => handleFind(p)}
            tableData={table.OverViewDataTable}
            callBack={(p) => handleDynamicColapse(p)}
            sendSearchedData={(p) => sendSearchedData(p)}
            allowDelivCol={(p) => allowDelivCol(p)}
            isMulti={false}
          />
          <div className="row float-right pr-4">
            <Button
              color="secondary"
              className="button-22"
              onClick={() => graph()}
              id="invoiceButton"
            >
              Graph
            </Button>
            <Decimal
              showAsInteger={showAsInteger}
              onToggle={setShowAsInteger}
            />
            <Button
              color="success"
              className="button-22 "
              onClick={() =>
                funPrintView(
                  table.printData,
                  listOfColLablesMt,
                  listOfColKeyMt,
                  data,
                )
              }
              id="invoiceButton"
            >
              Print
            </Button>

            {table?.listOfData?.length > 0 ? (
              <ExportToExcel
                Data={table?.listOfData}
                listOfColKey={listOfColKeyMt}
                DynamicReports={true}
                ReportName="Daily_Sale_Order_Wise_Report"
                criteriaString={data.criteriaString}
              />
            ) : null}
          </div>
          <div translate="no" className="mt-5">
            {/* <div
              style={{
                textAlign: "right",
                marginBottom: "1%",
                marginTop: "5%",
              }}
            >
              <input
                type="text"
                style={{ borderRadius: "5px", height: "28px" }}
                placeholder="Search entire table"
                value={searchText}
                onChange={handleSearch}
              />
            </div> */}
            <div className="sticky-table-wrapper">
              <div className="sticky-table-container">
                <PaginationProvider pagination={paginationFactory(options)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      {/* TOP Pagination Controls only */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                        {/* <PaginationListStandalone {...paginationProps} /> */}
                      </div>

                      <BootstrapTable
                        key={`sale-summary-table-${showAsInteger}`}
                        keyField="id"
                        data={filteredData}
                        columns={tableColumns}
                        defaultSorted={defaultSorted}
                        headerClasses="rpr_header"
                        tableBodyClass="rpr_body"
                        containerClass="rpr_container"
                        striped
                        condensed
                        hover
                        {...paginationTableProps}
                      />
                    </div>
                  )}
                </PaginationProvider>

                {/* <div>
              {table?.totalSumAll
                ? TableSumCustom(listOfSum, table.totalSumAll)
                : null}
            </div> */}
              </div>
            </div>
          </div>
        </div>

        {isLoading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
